/**
 * Simple count-up animation using requestAnimationFrame with an
 * ease-out curve. Renders a plain span so the parent controls
 * styling. Formatter defaults to R x xxx,xx.
 */
import { useEffect, useState } from "react";

const defaultFmt = (n) =>
  "R " +
  (Math.round(n) || 0).toLocaleString("en-ZA", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

export default function CountUp({ to = 0, duration = 1600, fmt = defaultFmt, className = "" }) {
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!to || to <= 0) {
      setVal(0);
      return;
    }
    const start = performance.now();
    let raf = 0;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      // easeOutCubic
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(to * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [to, duration]);

  return <span className={className}>{fmt(val)}</span>;
}
